/**
 * Ids of the buttons that live in a toolbar but are shown in the settings panel.
 *
 * Shared so the panel and the button agree on one string: the panel builds a row with the id,
 * the button portals into it (utils/settingsSlots). Renaming one here renames both ends.
 */
export const SETTINGS_ACTIONS = {
    /** «♻ Пересоздать перевод по правкам русского» — SubtitlesBlock. */
    recreateFromRu: "recreate-from-ru",
    /** «Пометить русский готовым» — SubtitlesBlock. */
    markRuDone: "mark-ru-done",
    /** «📤 Папка готова — в конвейер» — SubtitlesBlock, translation side only. */
    handIn: "hand-in",
    /** Republish state of the section — SubtitlesBlock. */
    republishBadge: "republish-badge",
    /** «Во все языки» — Head2. */
    allLanguages: "all-languages",
    /** «Update HLS» — Head2, streams only. */
    updateHls: "update-hls",
    /** «Доска управления» link — Head2. */
    managementBoard: "management-board",
    /** «Check Data» completeness probe — Head2. */
    checkData: "check-data",
} as const;
